var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 20,
    viewBox: "0 0 9 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.23616 9.95325H5.6512C5.6512 14.0607 5.6512 19.1165 5.6512 19.1165H1.8208C1.8208 19.1165 1.8208 14.1097 1.8208 9.95325H0V6.71468H1.8208V4.61992C1.8208 3.11966 2.5376 0.775391 5.6864 0.775391L8.5248 0.786211V3.92994C8.5248 3.92994 6.8 3.92994 6.46464 3.92994C6.12928 3.92994 5.65248 4.09671 5.65248 4.81215V6.71531H8.57088L8.23616 9.95325Z",
    fill: "#0A142F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.23616 9.95325H5.6512C5.6512 14.0607 5.6512 19.1165 5.6512 19.1165H1.8208C1.8208 19.1165 1.8208 14.1097 1.8208 9.95325H0V6.71468H1.8208V4.61992C1.8208 3.11966 2.5376 0.775391 5.6864 0.775391L8.5248 0.786211V3.92994C8.5248 3.92994 6.8 3.92994 6.46464 3.92994C6.12928 3.92994 5.65248 4.09671 5.65248 4.81215V6.71531H8.57088L8.23616 9.95325Z",
    fill: "url(#paint0_linear_96_2294)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_96_2294",
    x1: 4.26123,
    y1: 4.48129,
    x2: 4.25551,
    y2: 15.4734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#390EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9244F4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.8ebedd5a8acefcdb4e3cbff9e2877cfc.svg";
export { ForwardRef as ReactComponent };